export const translation ={
    "pag": {
        "titles": {
            "farm-main": "Main of {{name}}",
            "farm-external-link": "Viewing {{name}} of {{farm}}",
            "farm-consoles": "Consoles of {{name}}",
            "farm-technical-dashboards": "Technical dashboards of {{name}}",
            "farm-business-dashboards": "Business dashboards of {{name}}",
            "farm-properties": "Properties of {{name}}",
            "farm-gantt": "{{name}} / Planner",
            "farm-cycles": "{{name}} / Cycles",
            "farm-tasks": "{{name}} / Tasks",
            "farm-ai-planning": "AI PLANNING",
            "growunits": "Grow Units of {{name}}",
            "growunits-detail": "Main of {{name}}",
            "growunits-recipe": "Recipe of {{name}}",
            "growunits-layers": "Layers of {{name}}",
            "growunits-cycles": "Cycles of {{name}}",
            "growunits-planner": "Planner of {{name}}",
            "growunits-properties": "Properties of {{name}}",
            "product": "",
            "recipes": "",
            "recipes-edit": "",
            "crops": "",
            "crops-edit": "",
            "dashboard": "",
            "zw": "",
            "rkb": "",
            "preferences": "Preferences"
        },
        "default": {
            "action": {
                "add_request": "REQUEST",
                "show": "SHOW",
                "clone": "CLONE",
                "remove": "DELETE",
                "archive": "ARCHIVE",
                "restore": "RESTORE",
                "edit": "MODIFY",
                "move": "MOVE"
            }
        },
        "login": {
            "user": "Email",
            "password": "Password",
            "request": "Forgot password?",
            "login": "LogIn",
            "otp-code": "OTP Code",
            "back": "Back"
        },
        "otp": {
            "description": "Enter the OTP Code.\nYou can find it in your mobile or in the backup codes.",
            "force": {
                "title": "Security message",
                "text": "Please, enable TWO FACTOR AUTHENTICATION\nto improve the security of your account.",
                "ok": "Ok"
            }
        },
        "psw-request": {
            "title": "Send password reset email",
            "body": "Please enter your mail and submit to reset your password",
            "email": "E-mail",
            "submit": "Submit",
            "cancel": "Cancel",
            "confirm": {
                "title": "Reset email sent",
                "body": "check your email and follow the instructions to change your password",
                "close": "Close"
            }
        },
        "psw-reset": {
            "title": "Password change",
            "body": "Hi {{name}}. Enter the new password to reset the previous one",
            "password": "Password",
            "re-password": "Re Password",
            "submit": "Change",
            "cancel": "Cancel",
            "confirm": {
                "title": "Your password was successfully changed!",
                "body": "Close and try to login",
                "close": "Close"
            }
        },
        "crop": {
            "index": {
                "title": "|*LIST| of all CROPS LEGACY ",
                "name": "Name",
                "farms": "Farms",
                "actions": "Actions"
            },
            "detail": {
                "tab-days": {
                    "title": "DAYS",
                    "add-day": "DAY",
                    "add-phase": "PHASE",
                    "add-pre": "PRE-CYCLE",
                    "add-post": "POST-CYCLE",
                    "shrink": "Shrink",
                    "expand": "Expand"
                },
                "tab-general": {
                    "title": "GENERAL",
                    "name": "Name",
                    "name-holder": "No name inserted",
                    "article-code": "Article code",
                    "article-code-holder": "No article code inserted",
                    "tags": "Tags",
                    "tags-holder": "No tag inserted",
                    "farms": "Farms",
                    "variety": "Variety",
                    "variety-holder": "No variety inserted",
                    "vendor": "Vendor",
                    "vendor-holder": "No vendor inserted",
                    "pills-typology": "Pills typology",
                    "pills-typology-holder": "No typology inserted",
                    "cost-1kg": "Cost/1kg",
                    "cost-1kg-currency": "€",
                    "cost-million": "Seed cost/million",
                    "cost-million-currency": "€",
                    "seed-density": "Seed density",
                    "seed-density-sub": "max: 10",
                    "seed-pills-per-hd-tray": "Seed pills per hd tray",
                    "seed-pills-per-hd-tray-sub": "max: 10000",
                    "yield-per-mq": "Yield per mq"
                }
            }
        },
        "crop-recipe": {
            "index": {
                "title": "|*LIST| of all CROPS",
                "name": "Name",
                "farms": "Farms",
                "actions": "Actions"
            },
            "detail": {
                "tab-days": {
                    "title": "DAYS",
                    "add-day": "DAY",
                    "add-phase": "PHASE",
                    "add-pre": "PRE-CYCLE",
                    "add-post": "POST-CYCLE",
                    "shrink": "Shrink",
                    "expand": "Expand"
                },
                "tab-general": {
                    "title": "GENERAL",
                    "name": "Name",
                    "name-holder": "No name inserted",
                    "article-code": "Article code",
                    "article-code-holder": "No article code inserted",
                    "tags": "Tags",
                    "tags-holder": "No tag inserted",
                    "farms": "Farms",
                    "variety": "Variety",
                    "variety-holder": "No variety inserted",
                    "vendor": "Vendor",
                    "vendor-holder": "No vendor inserted",
                    "pills-typology": "Pills typology",
                    "pills-typology-holder": "No typology inserted",
                    "cost-1kg": "Cost/1kg",
                    "cost-1kg-currency": "€",
                    "cost-million": "Seed cost/million",
                    "cost-million-currency": "€",
                    "seed-density": "Seed density",
                    "seed-density-sub": "max: 10",
                    "seed-pills-per-hd-tray": "Seed pills per hd tray",
                    "seed-pills-per-hd-tray-sub": "max: 10000",
                    "yield-per-mq": "Yield per mq"
                }
            }
        },
        "product": {
            "index": {
                "title": "|*LIST| of all PRODUCTs",
                "name": "Name",
                "crops": "Crops",
                "actions": "Actions"
            },
            "detail": {
                "title-new": "New Product",
                "title-edit": "Edit Product",
                "title-clone": "Clone Product",
                "add": "Add Crop",
                "name": "NAME",
                "tags": "TAGS",
                "tags-holder": "No tag inserted",
                "description": "DESCRIPTION"
            },
            "new": {
                "title": "NEW ROW",
                "cancel": "Cancel",
                "add": "Add"
            }
        },
        "recipe": {
            "index": {
                "title": "|*LIST| of all RECIPEs",
                "name": "Name",
                "type": "Type",
                "farms": "Farms",
                "actions": "Actions"
            },
            "detail": {
                "tab-days": {
                    "title": "DAYS",
                    "add-day": "DAY",
                    "add-phase": "PHASE",
                    "title-common": "Common",
                    "temperature": "Temperature (C)",
                    "humidity": "Humidity (%)",
                    "photoperiod": "Photo period (hours)",
                    "irrigation": "Irrigation",
                    "led": "Led",
                    "ph": "PH",
                    "ec": "EC (mS)",
                    "co2": "<>CO<sub>2</sub> <span>(ppm)</span></>",
                    "day": "day",
                    "night": "night",
                    "duration": "duration",
                    "pause": "pause",
                    "bars": "bars",
                    "spectrum": "spectrum"
                },
                "tab-general": {
                    "title": "GENERAL",
                    "name": "Name",
                    "name-holder": "No name inserted",
                    "tags": "Tags",
                    "tags-holder": "No tag inserted",
                    "farms": "Farms"
                }
            }
        },
        "grow-unit": {
            "index": {
                "name": "Code",
                "type": "Type",
                "status": "Status",
                "mode": "Mode"
            },
            "edit-recipe": {
                "title": "RECIPE DEPLOY IN {{farm}}",
                "power": "POWER",
                "phase": "PHASE",
                "layers": "LAYER",
                "matrix-from-cycles": "SYNC RECIPE WITH CYCLES"
            },
            "detail": {
                "tab-main": {
                    "title": "MAIN",
                    "status": "STATUS:",
                    "current-recipe": "CURRENT RECIPE:",
                    "current-day": "CURRENT DAY:",
                    "value-current-day": "{{current}} of {{total}}",
                    "human": "HUMAN",
                    "root": "ROOT",
                    "play": "PLAY",
                    "pause": "PAUSE",
                    "rewind": "REWIND",
                    "jump": "JUMP",
                    "to-day": "To day:",
                    "options": {
                        "tooltip": "Optional actions to the farm",
                        "reconnect": "Reconnect offline farm",
                        "emu-apply-recipe": "Apply layers schema whithout ai recipe",
                        "emu-task-creation": "Emulate cycle task creation",
                        "emu-applied": "Emulate Applied",
                        "emu-error": "Emulate Error",
                        "emu-timeout": "Emulate Timeout",
                        "emu-status-applied": "Emulate status applied"
                    }
                },
                "tab-layers": {
                    "title": "LAYERS MAP",
                    "phase": "Phase",
                    "layers": "Layers",
                    "action": "Action",
                    "tooltip-water-shock": "Water shock"
                },
                "tab-cycles": {
                    "title": "CYCLES"
                },
                "tab-recipe": {
                    "title": "CURRENT RECIPE",
                    "name": "Name",
                    "date": "Date"
                },
                "tab-properties": {
                    "title": "PROPERTIES",
                    "farm-code": "Farm code",
                    "number-layers": "Number of layers",
                    "number-rows": "Number of rows",
                    "country": "Country",
                    "zip-code": "ZIP code",
                    "address": "Address",
                    "concurrent": "Concurrent layers per row",
                    "trolleys": "Trolleys per layer",
                    "trays": "Trays per trolley",
                    "bars": "Bars per trolley",
                    "total-layers-row": "Total layers per row",
                    "total-layers": "Total layers",
                    "total-trolleys": "Total trolleys",
                    "total-trays": "Total trays",
                    "total-bars": "Total bars"
                },
                "tab-scheduler": {
                    "title": "PLANNER",
                    "no-data": "There is no data for the chart",
                    "popup": {
                        "cycle-new": "New Cycle",
                        "cycle-detail": "Detail",
                        "task-new": "New Task",
                        "range": "Range"
                    }
                }
            }
        },
        "farm": {
            "index": {
                "title": "|*LIST| of all farms",
                "name": "Name",
                "code": "Code"
            },
            "detail": {
                "name": "Name",
                "address": "Address",
                "country": "Country",
                "zip-code": "ZIP Code",
                "airport-code": "Airport Code"
            },
            "external-links": {
                "index": {
                    "name": "Name",
                    "description": "Description",
                    "url": "Url",
                    "actions": "Actions",
                    "action-open-link-tooltip": "Open in new tab"
                }
            },
            "planner": {
                "desk": {
                    "task": "IT OPENS THE DRAWER OF TASKS",
                    "alert": "IT OPENS THE DRAWER OF ALERTS",
                    "stat": "IT OPENS THE DRAWER OF FARM PERFORMANCE"
                },
                "tabs": {
                    "preview": "Double click to view the PLAN."
                }
            }
        },
        "cycle": {
            "index": {
                "cycle-ref": "REF",
                "gu": "GROW UNIT",
                "crop": "CROP",
                "status": "STATUS",
                "seeding-date": "SEEDING DATE",
                "harvesting-layers": "HARVESTING LAYERS",
                "harvesting-date": "HARVESTING DATE",
                "planned-yield": "PLANNED YIELD (kg)",
                "yield": "YIELD (kg)",
                "units-yield": "UNITS YIELD",
                "actions": "Actions",
                "rejected": "rejected",
                "show-gantt": "View in Planner"
            },
            "edit": {
                "title": "CYCLE DETAIL",
                "title-preview": "CYCLE PREVIEW",
                "btt-harvest": "Harvest",
                "btt-harvest2": "Harvest",
                "btt-reject": "Reject",
                "btt-close": "Close",
                "btt-update": "Update",
                "btt-sync": "Sync",
                "yield-calc": "Yield:",
                "write-the-yield": "Write the yield (kg)",
                "ref": "REF",
                "gu": "GROW UNIT",
                "lot-code": "Lot code",
                "crop-name": "CROP NAME",
                "status": "STATUS",
                "harvesting-date": "HARVESTING DATE",
                "yield": "Yield (kg)",
                "planned-yield": "Planned Yield (kg)",
                "seeding-date": "SEEDING DATE",
                "day": "DAY",
                "delay": "Delay:",
                "note": "Note",
                "notes-delay": "Notes about the delay",
                "day-of": "{{current}} of {{total}}",
                "day-to-start": "{{days}} to start",
                "no-task": "NO TASKS",
                "no-only-read": "It is only possible in PROD",
                "no-harvest": "Cancel EDIT MODE to enable this button",
                "tab": {
                    "details": "DETAILS",
                    "crop-lots": "CROP LOTS",
                    "tasks": "TASKS",
                    "consumption": "CONSUMPTION",
                    "incidents": "INCIDENTS",
                    "photos": "PHOTOS"
                },
                "crop-lots": {
                    "trolleys-to-seed": "Seed trolleys",
                    "trolleys-to-harvest": "Harvest trolleys"
                }
            },
            "new": {
                "title": "PLAN A NEW CYCLE",
                "chip": {
                    "select-crop": "Select a crop",
                    "select-crop-tooltip": "",
                    "rearrangment": "Rearrangment",
                    "rearrangment-tooltip": "Select the number of layers in relation to their ratio",
                    "all-phases": "All phases",
                    "all-phases-tooltip": "Select at least one layer for each phase",
                    "overlap": "Overlap",
                    "overlap-tooltip": "Some layers overlap on this date",
                    "nolayer": "No layer",
                    "nolayer-tooltip": "There are no layers. Try to change crop",
                    "past": "Date in the past",
                    "past-tooltip": "Select today's date or later"
                },
                "btt-cancel": "CANCEL",
                "btt-create": "CREATE",
                "crop": "CROP LEGACY",
                "growunit": "GROW UNIT",
                "prg-date": "SEEDING DATE"
            },
            "selector": {
                "phases-ratio": "Phases (ratio)",
                "layers": "Layers"
            }
        },
        "root": {
            "title": "Root"
        },
        "pref": {
            "2fa": {
                "title": "Two Factor Authentication",
                "enabled": "Enabled",
                "disabled": "Disabled",
                "enabled-desc": "Click on the switch to disable 2FA",
                "disabled-desc": "Click on the switch to enable 2FA"
            }
        },
        "alarm": {
            "index": {
                "title": "|*LIST| of all alert rules",
                "code": "Code",
                "typology": "Overrides",
                "description": "Description",
                "actions": "Actions"
            },
            "detail": {
                "title-new": "New Alarm",
                "title-edit": "Edit Alarm",
                "title-clone": "Clone Alarm",
                "code": "Code",
                "code-holder": "The unique code",
                "description": "Description",
                "description-holder": "A description of the alarm",
                "wikiUrl": "Wiki URL",
                "wikiUrl-holder": "The URL of the documentation",
                "wikiUrl-tooltip": "The link will open in a new tab",
                "typo": "Typologies",
                "typo-holder": "The types to be overwritten",
                "teams": "Competence",
                "teams-holder": "Whose competence is it",
                "severity": "Severity",
                "task-group": "Task Group",
                "task-group-holder": "Tasks to be created automatically",
                "add-override": "Add Override"
            }
        },
        "task": {
            "actions": {
                "filter": {
                    "growunit": "Filter by Grow Unit",
                    "scope": "Filter by Scope",
                    "cycle": "Show only this cycle",
                    "reset": "Reset"
                },
                "planner": "View in planner"
            }
        },
        "prod": {
            "sol": {
                "score": "Score",
                "yield-week": "Yield per week",
                "period-yield": "Period yield",
                "layers-harvested-week": "Layers harv. week",
                "yield-per-week": "Yield per week",
                "layers-harvest": "Layers harvested",
                "crop": "Crop",
                "on-total": "On total",
                "yield-week-max-harvests": "Yield week max harvests",
                "yield-zero-meter": "Yield zero square meter",
                planner: {
                    add: "ADD THE PREVIEW IN THE PLANNER",
                    show: "SHOW PREVIEW IN PLANNER",
                    lab: "SHOW IN LABS PLANNER",
                },
                "comparison": "View this PLAN in the COMPARE section.",
                "reference": "Difference in results compared to this PLAN."
            },
            "req": {
                "name": "NAME",
                "name-h": "SOLUTION IDENTIFIER",
                "product": "PRODUCT",
                "product-h": "PRODUCTS INVOLVED IN THE SOLUTION",
                "range": "DATE RANGE",
                "range-h": "DATE RANGE OF THE PLAN",
                "layout": "FARM LAYOUT",
                "layout-h": "SELECT AND RESTRICT THE SOLUTION TO SPECIFIC FARM SECTIONS",
                "only_on": "HARVEST ONLY ON",
                "only_on-h": "DAYS OF THE WEEK SUITABLE FOR HARVESTING",
                "seeding_only_on": "SEEDING ONLY ON",
                "seeding_only_on-h": "DAYS OF THE WEEK SUITABLE FOR SEEDING",
                "dayoff": "DAYS OFF",
                "dayoff-h": "SELECT WEEKLY OR CALENDAR-DEFINED NON-WORKING DAYS",
                "per_period": "HARVESTS PER PERIOD",
                "per_period-h": "CHOOSE THE NUMBER OF HARVESTS PER TIME PERIOD",
                "period": "HARVEST PERIOD",
                "period-h": "SPECIFY THE DAYS WITHIN THE TIME PERIOD",
                "workload": "MAX DAILY WORKLOAD",
                "workload-h": "MAXIMUM NUMBER OF WORK HOURS PER DAY ON THE FARM",
                "layers": "LAYERS PER HARVEST",
                "layers-h": "MAXIMUM NUMBER OF LAYERS THE FARM CAN HARVEST PER DAY",
                "elastic": "ELASTIC PHASES",
                "multi": "MULTI GROUP TRIES",
                "yield-error": "YIELD ERROR (%)",
                "timeout": "TIMEOUT PER ITERATION"
            },
            "action": {
                "remove": "Remove",
                "add_request": "SOLUTION"
            }
        },
        "modules": {
            "title": "Modules",
            "new_value": "This value is new",
            "no_value": "Click and set a value",
            "new_meta": "METADATA"
        },
        "meta": {
            "title": "Metadata",
            "table": {
                "code": "Code",
                "name": "Name",
                "desc": "Description",
                "type": "Type",
                "um": "U.M.",
                "target": "Target",
                "alias": "Alias",
                "role": "Role",
                "group": "Group",
                "graphed": "This metadata is graphed"
            }
        },
        "subsys": {
            "nds": {
                "title": "NDS"
            },
            "irrigation": {
                "title": "IRRIGATION"
            },
            "adj": {
                "title": "ADJ"
            },
            "light": {
                "title": "LIGHT"
            },
            "towers": {
                "irrigation": {
                    "on": "IRRIGATION IN PROGRESS",
                    "off": "IRRIGATION OFF"
                },
                "light": {
                    "on": "LIGHTS ON",
                    "off": "LIGHTS OFF"
                },
                "status": {
                    "on": "ENABLED",
                    "off": "DISABLED",
                    "disaligned": "DISALIGNED"
                },
                "mode": {
                    "override": "ROOT",
                    "local": "HUMAN"
                },
                "fan": {
                    "on": "ON",
                    "off": "OFF"
                }
            },
            "refill": {
                "alert": {
                    "select": "SELECT AT LEAST ONE TANK",
                    "counter": "INCREASE DESIRED OR RESET COUNTER"
                },
                "tooltip": {
                    "max": "MAXIMUM LEVEL REACHED",
                    "min": "MINIMUM LEVEL REACHED"
                }
            }
        }
    },
    "footer": {
        "crops": {
            "new": "New Crop",
            "save": "Save Changes",
            "cancel": "Cancel"
        },
        "crops-recipes": {
            "new": "New Crop-Recipe",
            "save": "Save Changes",
            "cancel": "Cancel"
        },
        "product": {
            "new": "New Product",
            "save": "Save Changes",
            "cancel": "Cancel"
        },
        "alarm": {
            "new": "New Alarm",
            "save": "Save Changes",
            "cancel": "Cancel"
        },
        "recipes": {
            "new": "New Recipe",
            "save": "Save",
            "cancel": "Cancel"
        },
        "farms": {
            "edit-recipe": "Deploy recipe",
            "new-cycle": "New Cycle",
            "edit-gantt": "Edit",
            "save-gantt": "Save",
            "cancel-gantt": "Cancel"
        },
        "tasks": {
            "edit": "Edit",
            "save": "Save",
            "new_cycle": "New Cycle",
            "res_cycle": "Restore Cycle",
            "new_task": "New Task",
            "promote": "PROMOTE",
            "cancel": "Cancel",
            "restore": "Restore",
            "multiedit": "Multiedit",
            "delete": "Delete",
            "deselect": "Deselect",
            "sync": "Sync"
        },
        "planner": {
            "new_cycle": "NEW CYCLE",
            "del_cycle": "DEL CYCLE"
        },
        "draft": {
            "apply": "APPLY",
            "delete": "DELETE",
            "rename": "RENAME",
            "draft": "NEW DRAFT"
        },
        "productions": {
            "new_prod": "AI PLAN",
            "new_req": "PROPOSE SOLUTION",
            "deselect": "DESELECT"
        },
        "meta": {
            "new": "NEW METADATA"
        }
    },
    "selector": {
        "select": "Click to select",
        "phases": "Select a Phase",
        "cycles": "Select a Cycle",
        "crop": "Select a Crop",
        "task-g-t": "Select Task Group Template",
        "phases-readonly": "",
        "multi-tasks-holder": "No tasks on this day",
        "nutrients": "Select a Nutrinet Solution",
        "targets": "Select a Target Solution",
        "week": "Select a day of the week",
        "ttgs": "Select ne or more Task Template Groups",
        "recipe": {
            "paragraph": "RECIPE",
            "label": "Select a Recipe"
        },
        "task": {
            "placeholder": "Select a task groups",
            "no-tasks": "There are no TASKS for this group"
        },
        "task-scope": {
            "placeholder": "Select a scope"
        },
        "range-date": {
            "start": "Start",
            "end": "End",
            "tooltip": "SELECTED DATE RANGE"
        },
        "farm": {
            "title": "Select one or more FARMs"
        },
        "scope": {
            "title": "Select a Scope",
            "tooltip": "FILTER ON SCOPE"
        },
        "growunit": {
            "title": "SELECT A GROW UNIT",
            "tooltip": "FILTER ON GROW UNIT"
        },
        "severity": {
            "title": "Select a Severity",
            "tooltip": "FILTER ON SEVERITY"
        },
        "status": {
            "title": "Select a Status",
            "tooltip": "FILTER ON STATUS"
        },
        "drafts": {
            "list": {
                "title": "Draft library",
                "placeholder": "search the text"
            },
            "status": {
                "title": "Filter from status"
            },
            "filter": {
                "currents": "IN PROGRESS",
                "merged": "MERGED"
            }
        },
        "session": {
            "title": "Select a Session",
            "tooltip": "TAB SELECTED IN THE PLANNER"
        },
        "production": {
            "filter": {
                "title": "AI PLANS FILTER",
                "tooltip": "DO YOU WANT TO SEE THE ARCHIVED AI PLANS?"
            },
            "ref": {
                "tooltip": "SHOW ME THE REFERENCE PROPOSAL"
            }
        },
        "type": "Type",
        "service": {
            "title": "SELECT A SERVICE CODE",
            "tooltip": "FILTER ON SERVICE CODE"
        },
        "group": {
            "title": "SELECT A GROUP",
            "tooltip": "FILTER ON GROUP"
        },
        "subsys_state": {
            "title": "SELECT A STATE",
            "tooltip": "CLICK TO CHANGE STATE"
        },
        "main_mode": {
            "title": "SELECT A MODE",
            "tooltip": "CLICK TO CHANGE STATE"
        }
    },
    "menu": {
        "home": {
            "label": "HOME"
        },
        "main": {
            "label": "MAIN"
        },
        "modules": {
            "label": "MODULES"
        },
        "metadata": {
            "label": "METADATA"
        },
        "farms": {
            "label": "FARMS",
            "growUnits": {
                "label": "COMPONENTS",
                "layers": "TOWERS",
                "recipe": "RECIPE",
                "planner": "PLANNER",
                "cycles": "CYCLES",
                "properties": "PROPERTIES"
            },
            "gu": {
                "label": "COMPONENTS",
                "layers": "LAYERS",
                "actions": "ACTIONS",
                "adj": "ADJUSTMENTS",
                "lighting": "LIGHTING",
                "lighting_ps": "LIGHTING P.S.",
                "irrigation": "IRRIGATION",
                "powmonitor": "POWER MONITOR",
                "germinator": "GERMINATOR",
                "hvac": "HVAC"
            },
            "planner": "PLANNER",
            "cycles": "CYCLES",
            "tasks": "TASKS",
            "productions": "AI PLANNING",
            "alerts": "ALERTS",
            "charts": "CHARTS",
            "consoles": "CONSOLES",
            "technicalDashboards": "TECH DASH",
            "businessDashboards": "BI DASH",
            "externalLink": "DASHBOARDS"
        },
        "recipes": "RECIPES",
        "crops": "CROPS LEGACY",
        "crops_recipes": "CROPS",
        "products": "PRODUCTS",
        "alarms": "ALERT RULES",
        "root": "ROOT",
        "zw": "WIKI"
    },
    "chips": {
        "farm": {
            "tooltip": "GROW UNIT CURRENTLY SELECTED."
        },
        "recipe-type": "THE TYPE OF THE SELECTED RECIPE",
        "warn-concurrent": {
            "label": "NO CONCURRENT",
            "tooltip": "THERE ARE NO CONCURRENT LAYERS ON THE FARM."
        },
        "warn-layer": {
            "label": "No LAYER",
            "tooltip": "There are no LAYERS on the farm."
        },
        "warn-no-recipe": {
            "label": "SELECT RECIPE",
            "tooltip": "SELECT A RECIPE"
        },
        "warn-no-phases": {
            "label": "No PHASEs",
            "tooltip": "All active LAYERS should be be PHASE"
        },
        "warn-no-batch-phases": {
            "label": "No phases in BATCH",
            "tooltip": "Change all empty phases or disable the layer"
        },
        "warn-no-all-phases": {
            "label": "Select all PHASES",
            "tooltip": "All avaliable PHASES should be selected"
        },
        "warn-cycleactive": {
            "label": "Active CYCLES",
            "tooltip": "End all active CYCLES of this FARM"
        },
        "warn-layersdisabled": {
            "label": "LAYERS disabled",
            "tooltip": "Enable at least one LAYER"
        }
    },
    "snackbar": {
        "cycle": {
            "defined": "CYCLE DEFINED SUCCESSFUL",
            "error": "AN ERROR HAS OCCURRED. TRY AGAIN",
            "update": "CYCLE UPDATE SUCCESSFUL",
            "delay": "THE CYCLE HAS BEEN UPDATED",
            "harvested": "THE CYCLE WAS HARVESTED",
            "reject": "THE CYCLE WAS REJECTED",
            "split": "THE CYCLE WAS SPLIT SUCCESSFULLY"
        },
        "crop": {
            "update": "CROP UPDATE SUCCESSFUL",
            "create": "CROP CREATE SUCCESSFUL",
            "archive": "THE CROP HAS BEEN ARCHIVED",
            "bulk-archive": "THE SELECTED CROPS HAVE BEEN ARCHIVED",
            "restore": "CROP RESTORE SUCCESSFUL"
        },
        "crop-recipe": {
            "update": "CROP-RECIPE UPDATE SUCCESSFUL",
            "create": "CROP-RECIPE CREATE SUCCESSFUL",
            "archive": "THE CROP-RECIPE HAS BEEN ARCHIVED",
            "bulk-archive": "THE SELECTED CROP-RECIPE HAVE BEEN ARCHIVED",
            "restore": "CROP-RECIPE RESTORE SUCCESSFUL"
        },
        "product": {
            "update": "PRODUCT UPDATE SUCCESSFUL",
            "create": "PRODUCT CREATE SUCCESSFUL",
            "archive": "THE PRODUCT HAS BEEN ARCHIVED",
            "restore": "PRODUCT RESTORE SUCCESSFUL"
        },
        "recipe": {
            "update": "RECIPE UPDATE SUCCESSFUL",
            "create": "RECIPE CREATE SUCCESSFUL",
            "delete": "THE RECIPE HAS BEEN DELETED",
            "archive": "THE RECIPE HAS BEEN ARCHIVED",
            "bulk-archive": "THE SELECTED RECIPES HAVE BEEN ARCHIVED",
            "restore": "RECIPE RESTORE SUCCESSFUL"
        },
        "task": {
            "sync": "TASK SYNCHRONIZED SUCCESSFULLY"
        },
        "farm": {
            "deploy": "RECIPE DEPLOY SUCCESSFULLY"
        },
        "alarm": {
            "update": "ALARM UPDATE SUCCESFUL",
            "delete": "THE ALARM HAS BEEN DELETED"
        },
        "default": {
            "edit-start": "START EDIT MODE",
            "save": "THE CHANGES HAVE BEEN SAVED",
            "modify": "THE CHANGE HAS BEEN MADE",
            "new": "CREATION SUCCESSFUL",
            "delete": "ITEM SUCCESSFULLY DELETED",
            "restore": "END EDIT MODE. THE CHANGES HAVE BEEN CANCELLED"
        }
    },
    "dialog": {
        "default": {
            "info": {
                "title": "INFO",
                "btt-ok": "Ok",
                "btt-cancel": ""
            },
            "warning": {
                "title": "WARNING!",
                "btt-ok": "Yes",
                "btt-cancel": "No!"
            },
            "modal": {
                "btt-cancel": "Cancel",
                "btt-ok": "Ok"
            },
            "error": {
                "title": "ERROR",
                "btt-ok": "Ok",
                "btt-cancel": ""
            },
            "cancel": "Cancel",
            "ok": "Ok",
            "clear": "Clear",
            "close": "Close",
            "create": "Create",
            "rename": "Rename",
            "apply": "Apply"
        },
        "edit": {
            "delete-permanent": "THIS OPERATION IS NOT REVERSIBLE.\nARE YOU SURE YOU WANT TO DELETE THIS ITEM?"
        },
        "render_error": {
            "title": "Rendering error",
            "body": "Change page and reload.",
            "reload": "RELOAD"
        },
        "ajax": {
            "ok": "OK",
            "title": "Ajax ERROR",
            "text": "Generic error",
            "401": {
                "login": {
                    "text": "Wrong email or password."
                },
                "otp-code": {
                    "text": "Wrong email or password or OTP code."
                },
                "title": "Autenthication ERROR",
                "text": "The TOKEN has probably expired. Log in again."
            },
            "404": {
                "text": "Service does not exist."
            },
            "403": {
                "title": "ACTION NOT ALLOWED",
                "text": "You do not have access to this service.\nContact the administrator for more information."
            },
            "422": {
                "crop_used_in_products": {
                    "title": "CROP IN USE",
                    "text": "Failed to discard crop, remove it from products: {{d0}} before discard."
                }
            },
            "grow_units": {
                "layers_busy_error": {
                    "title": "Failed to deploy the RECIPE",
                    "text": "A layer currently being used by a cycle has been disabled."
                }
            }
        },
        "cycle": {
            "reject": {
                "confirm": "Do you really want to reject this CYCLE?"
            },
            "overlap-cont": "There are overlapping layers (marked in red).\nTry changing them or moving the date",
            "overlap-batch": "There are overlapping layers.\nTry moving the date"
        },
        "crop": {
            "archive": {
                "confirm": "Are you sure you want to archive the CROP?"
            },
            "bulk-archive": {
                "confirm": "Are you sure you want to archive the selected CROPS?"
            },
            "update": {
                "watch-days": "Watch out. you didn't edit the days."
            },
            "delete-last-day": {
                "title": "Operation not allowed",
                "text": "A phase must have at least one day"
            },
            "delete-last-phase": {
                "title": "Operation not allowed",
                "text": "There must be at least one phase"
            },
            "select": {
                "title": "SELECT A CROP"
            },
            "ratio": {
                "text": "the ratio of a phases must be a multiple of the previous ratio"
            }
        },
        "crop-recipe": {
            "archive": {
                "confirm": "Are you sure you want to archive the CROP-RECIPE?"
            },
            "bulk-archive": {
                "confirm": "Are you sure you want to archive the selected CROPS?"
            },
            "update": {
                "watch-days": "Watch out. you didn't edit the days."
            },
            "delete-last-day": {
                "title": "Operation not allowed",
                "text": "A phase must have at least one day"
            },
            "delete-last-phase": {
                "title": "Operation not allowed",
                "text": "There must be at least one phase"
            },
            "select": {
                "title": "SELECT A CROP"
            },
            "ratio": {
                "text": "the ratio of a phases must be a multiple of the previous ratio"
            }
        },
        "product": {
            "archive": {
                "confirm": "Are you sure you want to archive the PRODUCT?"
            },
            "invalid": {
                "title": "Wrong parameters",
                "text": "The total of all percentages must be equal to or less than 100,"
            },
            "select": {
                "title": "SELECT A PRODUCT"
            }
        },
        "farm": {
            "pause": {
                "confirm": "You really want to PAUSE the farm?"
            },
            "cycle": {
                "no-recipe": {
                    "title": "There is no RECIPE in the FARM",
                    "text": "To create a CYCLE deploy a RECIPE in the FARM \nIn TAB MAIN click 'DEPLOY RECIPE' button.",
                    "btt-ok": "Ok",
                    "btt-cancel": ""
                }
            },
            "recipe": {
                "busy": "There are CYCLEs in disabled LAYERs to enable:\n{{layers}}"
            }
        },
        "recipe": {
            "archive": {
                "confirm": "Are you sure you want to archive the RECIPE?"
            },
            "bulk-archive": {
                "confirm": "Are you sure you want to archive the selected RECIPES?"
            },
            "edit-day": {
                "title": "Attention",
                "text": "Watch out. you didn't edit the days."
            },
            "delete": "Are you sure you want to delete the RECIPE?",
            "schema": {
                "title": "LET'S CREATE A NEW RECIPE",
                "text": "What kind of recipe do you want to create?"
            },
            "select": {
                "title": "SELECT A RECIPE"
            }
        },
        "task": {
            "title": "TASK DETAIL",
            "title-preview": "TASK GROUP PREVIEW",
            "btt-close": "Close",
            "btt-cancel": "Cancel",
            "btt-confirm": "Confirm",
            "btt-delete": "Delete",
            "details": {
                "title": "DETAIL",
                "ref": "REF",
                "subject": "SUBJECT",
                "description": "DESCRIPTION",
                "scope": "SCOPE",
                "date-time": "DATE/TIME",
                "date": "Date",
                "time": "TIME",
                "points": "POINTS",
                "points-trolley": "TROLLEYS POINTS",
                "updates-yield": "UPDATES YIELD",
                "cancel-if-cycle-rejected": "DELETE REJECTED",
                "related-to": "RELATED TO",
                "closure": "CLOSURE AT"
            },
            "subtasks": {
                "title": "Subtasks",
                "void": "THERE ARE NO SUB-TASKS"
            },
            "new": {
                "title": "NEW TASK",
                "btt-create": "Create",
                "btt-cancel": "Cancel",
                "detail": {
                    "title": "Detail",
                    "groups": "GROUPS",
                    "templates": "TEMPLATES",
                    "templates-void": "Select an item in the 'Groups' field",
                    "date-range": "DATE RANGE",
                    "date-start": "Start",
                    "date-end": "End",
                    "date-step": "STEP: {{day}} DAY"
                },
                "preview": {
                    "title": "Preview"
                }
            },
            "multiedit": {
                "title": "MULTI EDIT TASKS",
                "btt-cancel": "Cancel",
                "btt-confirm": "Confirm",
                "indeterminate": "type to edit all",
                "indeterminate-select": "select to edit all"
            },
            "drawer": {
                "new": "NEW TASK",
                "edit": "Edit",
                "delete": "Delete",
                "sync": "Sync",
                "tlt-select-all": "Select all TASKs",
                "tlt-edit": "Multi edit selected TASKs",
                "tlt-sync": "Synchronize the TASKS with their respective TEMPLATES",
                "tlt-delete": "Delete all selected TASKs"
            }
        },
        "user": {
            "logout": "LOGOUT",
            "preferences": "PREFERENCES"
        },
        "setup2fa": {
            "title": "Startup 2FA",
            "ok": "Submit",
            "cancel": "Cancel",
            "qrcode": "QR Code",
            "otp-code": "OTP Code",
            "otp-secret": "OTP Secret",
            "password": "Password",
            "otp-copied": "The code has been copied to the clipboard"
        },
        "backups-codes": {
            "title": "Backup OTP codes",
            "description": "Take note of the codes you see.\nYou might need them in an emergency.",
            "copy": "Copy & close",
            "close": "Close"
        },
        "tag": {
            "title": "Define or create TAGs",
            "label": "Filter or new TAG",
            "add-tag": "Add new TAG:"
        },
        "alarm": {
            "delete": "Are you sure you want to delete the ALARM?",
            "warn-save": "There are errors in the form.\nPlease correct them and try again, thanks!"
        },
        "alert": {
            "title": "ALERT",
            "description": "DESCRIPTION",
            "severity": "SEVERITY",
            "status": "STATUS",
            "opened": "OPENED",
            "closed": "CLOSED",
            "team": "TEAM",
            "growunit": "GROW UNIT",
            "wiki": "WIKI",
            "behaviour": "CODE",
            "alertname": "ALARM NAME"
        },
        "production": {
            "new": {
                "title": "NEW AI PLAN",
                "name": "Name",
                "range": "Range"
            }
        },
        "request": {
            "title": {
                "new": "NEW SOLUTION",
                "show": "SOLUTION"
            },
            "options": "ADVANCED OPTIONS"
        },
        "planner": {
            "load-draft": {
                "title": "There is a pending DRAFT",
                "text": "Do you want to load the latest modified DRAFT?",
                "ok": "Yes, restore",
                "cancel": "No! Cancel"
            }
        },
        "draft": {
            "new": {
                "title": "NEW DRAFT"
            },
            "promote": {
                "title": "PROMOTE IN...",
                "mode-new": "NEW DRAFT",
                "mode-existing": "EXISTING DRAFT",
                "search-placeholder": "Search draft..."
            },
            "apply": {
                "title": "SAVE IN PRODUCTION",
                "text": "You are applying the current DRAFT in PRODUCTION\nDo you confirm it?",
                "cancel": "NO!",
                "ok": "YES APPLY",
                "confirm": "I confirm I want to modify the PRODUCTION plan."
            },
            "overlap": {
                "title": "IMPOSSIBLE TO SAVE",
                "text": "There are some CYCLE overlaps in the PLANNER.\nTry modifying the CYCLES so as not to have overlaps",
                "ok": "OK"
            },
            "delete": {
                "title": "PERMANENT CANCELLATION OF THE DRAFT",
                "text": "ATTENTION!\nDo you want to permanently delete this DRAFT?",
                "ok": "Yes, Delete"
            }
        },
        "module": {
            "title": "EDIT MODULE",
            "name": "NAME",
            "metadata": "METADATA",
            "selected": "METADATA SELECTED"
        },
        "meta": {
            "title-edit": "EDIT EXISTING METADATA",
            "title-new": "CREATE NEW METADATA",
            "delete": "Are you sure you want to delete this METADATE?",
            "name": "NAME",
            "service-code": "SERVICE CODE",
            "desc": "DESCRIPTION",
            "target": "TARGET",
            "um": "UNIT OF MEASURE",
            "label-on": "LABEL ON",
            "label-off": "LABEL OFF",
            "min": "MINIMUM VALUE",
            "max": "MAXIMUM VALUE",
            "type": "TYPE",
            "value": "LAST VALUE",
            "decimals": "DECIMALS",
            "readonly": "READ ONLY",
            "graph": "IS METRIC",
            "group": "GROUP",
            "alias": "ALIAS"
        },
        "main": {
            "stop": {
                "text": "With this operation you will stop the whole system",
                "confirm": "Are you sure you want to proceed?",
                "ok": "Yes, stop everything",
                "cancel": "No, cancel"
            }
        }
    },
    "drawer": {
        "crop": {
            "title": "FILTERS",
            "archived": "Archived"
        },
        "task": {
            "title": "TASKS",
            "no-cycle": "No Crop",
            "filter": {
                "filter": "Filter"
            }
        },
        "cycle": {
            "title": "FILTERS",
            "title-range": "Visible range",
            "title-type": "Visible type",
            "planned": "Planned",
            "running": "Running",
            "harvested": "Harvested",
            "rejected": "Rejected",
            "reset": "Reset"
        },
        "gantt": {
            "title": "FILTERS",
            "title-range": "Visible range",
            "reset": "Reset"
        },
        "planner": {
            "filter": {
                "title": "FILTERS",
                "range": "Visible Range"
            }
        },
        "common": {
            "reset": "Reset",
            "filters": "FILTERS",
            "range": "Visible Range"
        }
    },
    "app": {
        "farm": {
            "status": {
                "unknow": "unknow",
                "idle": "idle",
                "running": "running",
                "paused": "paused",
                "waiting": "waiting",
                "offline": "offline"
            },
            "typology": {
                "M": "Manual",
                "S": "Small",
                "L": "Large",
                "C": "Cannabis",
                "X": "Lab",
                "R": "Container",
                "G": "Germination",
                "ZR11_VBS": "ZR11_VBS",
                "ZR13_RUH": "ZR13_RUH",
                "ZR14_AUH": "ZR14_AUH",
                "ZR18_LPK": "ZR18_LPK",
                "ZR19_NAP": "ZR19_NAP",
                "FFI00_VCE": "FFI00_VCE"
            }
        },
        "recipe": {
            "type": {
                "batch": "BATCH",
                "continuous": "CONTINUOUS"
            },
            "nothing": "Nothing"
        },
        "phases": {
            "_batch": "BATCH",
            "_pre-cycle": "PRE CYCLE",
            "_post-cycle": "POST CYCLE",
            "germination": "germination",
            "growing": "growing",
            "hd-growing": "HD growing",
            "ld-growing": "LD growing",
            "generic-1": "generic 1",
            "generic-2": "generic 2",
            "generic-3": "generic 3",
            "generic-4": "generic 4",
            "generic-5": "generic 5",
            "generic-6": "generic 6",
            "generic-7": "generic 7",
            "generic-8": "generic 8",
            "generic-9": "generic 9",
            "generic-10": "generic 10",
            "generic-11": "generic 11",
            "generic-12": "generic 12",
            "generic-13": "generic 13",
            "generic-14": "generic 14",
            "generic-15": "generic 15",
            "generic-16": "generic 16",
            "generic-17": "generic 17",
            "generic-18": "generic 18",
            "generic-19": "generic 19",
            "generic-20": "generic 20",
            "null": "..."
        },
        "months": {
            "0": "January",
            "1": "February",
            "2": "March",
            "3": "April",
            "4": "May",
            "5": "June",
            "6": "July",
            "7": "August",
            "8": "September",
            "9": "October",
            "10": "November",
            "11": "December"
        },
        "months_short": {
            "0": "Jan",
            "1": "Feb",
            "2": "Mar",
            "3": "Apr",
            "4": "May",
            "5": "Jun",
            "6": "Jul",
            "7": "Aug",
            "8": "Sep",
            "9": "Oct",
            "10": "Nov",
            "11": "Dec"
        },
        "week": {
            "0": "Sunday",
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday"
        },
        "week2": {
            "0": "Sun",
            "1": "Mon",
            "2": "Tue",
            "3": "Wed",
            "4": "Thu",
            "5": "Fri",
            "6": "Sat"
        },
        "cycle": {
            "warn": {
                "phase": "The cycle crop PHASE differs from the one in the deployed RECIPE",
                "duration": "The DURATION differs from the one in the deployed RECIPE",
                "general": {
                    "chip": "Inconsistent LAYER",
                    "tooltip": "There is a problem in a LAYER of this CYCLE"
                }
            }
        },
        "alarm": {
            "critical": "Critical",
            "high": "High",
            "moderate": "Moderate",
            "low": "Low",
            "information": "Information"
        },
        "teams": {
            "production_manager": "Production Manager",
            "technical_manager": "Technical Manager",
            "engineers": "Engineers",
            "agro_guys": "Agro Guys",
            "ict_guys": "ICT Guys"
        },
        "alert": {
            "filter": {
                "open": "OPEN",
                "not_seen": "NOT SEEN",
                "not_acknowlaged": "NOT ACKNOWLAGED",
                "all": "ALL",
                "acknowlaged": "ACKNOWLAGED",
                "closed": "CLOSED"
            },
            "status": {
                "open": "OPEN",
                "seen": "SEEN",
                "acknowlaged": "ACK'ED",
                "close": "CLOSE"
            },
            "status_ext": {
                "open": "OPEN",
                "seen": "SEEN",
                "acknowlaged": "ACKNOWLAGED",
                "close": "CLOSE"
            }
        },
        "task": {
            "status": {
                "cancelled": "CANCELLED",
                "open": "TO DO",
                "open_late": "OVERDUE",
                "close": "DONE",
                "close_late": "LATE ({{min}})"
            },
            "preview": "IN PREVIEW"
        },
        "production": {
            "status": {
                "active": "ACTIVE",
                "archived": "ARCHIVED"
            }
        },
        "draft": {
            "status": {
                "init": "FROM PROD",
                "promoting_from_solution": "BUILDING",
                "promoted_from_solution": "FROM AI",
                "applying": "APPLIED",
                "applied": "APPLIED"
            }
        },
        "nats": {
            "cnn": {
                "unk": "UNKNOW",
                "on": "ONLINE",
                "rty": "RETRY",
                "off": "OFFLINE"
            }
        },
        "main": {
            "mode": {
                "1": "ROOT",
                "2": "HUMAN"
            }
        },
        "layer": {
            "rootmode": {
                "tooltip": {
                    "0": "LAYER OFF",
                    "1": "LAYER ON",
                    "2": "LAYER UNDER ROOT COMMAND"
                },
                "label": {
                    "0": "OFF",
                    "1": "ON",
                    "2": "SCHEDULED"
                }
            },
            "localmode": {
                "tooltip": {
                    "0": "LAYER ON",
                    "1": "LAYER UNDER ROOT COMMAND",
                    "2": "LAYER OFF"
                },
                "label": {
                    "1": "ON",
                    "2": "SCHEDULED",
                    "0": "OFF"
                }
            }
        },
        "subsys": {
            "state": {
                "0": "OFF",
                "2": "AUTO",
                "1": "MANUAL"
            }
        },
        "adj": {
            "status": {
                "v1": {
                    "0": "ADJUSTMENT SYSTEM DISABLED",
                    "1": "STAND BY...",
                    "2": "PREMIX",
                    "3": "CHOOSE ACTION",
                    "4": "ADDING BASE...",
                    "5": "ADDING ACID...",
                    "6": "ADDING A + B...",
                    "7": "ADDING H2O...",
                    "8": "ADJUSTMENT COMPLETING...",
                    "9": "ADJUSTMENT COMPLETING...",
                    "50": "ADJ SYSTEM PRESTART...",
                    "51": "ADJ SYSTEM PRESTART..."
                },
                "v2": {
                    "0": "ADJUSTMENT SYSTEM DISABLED",
                    "1": "STAND BY...",
                    "2": "PREMIX",
                    "3": "CHOOSE ACTION",
                    "4": "PRESTART INITIALIZE...",
                    "5": "PRESTART...",
                    "6": "ADJUSTING...",
                    "8": "STOP PUMP...",
                    "9": "CLOSING..."
                }
            },
            "ph": {
                "base": "ADD BASE",
                "acid": "ADD ACID",
                "none": "SO FAR SO GOOD"
            },
            "ec": {
                "a+b": "ADD A + B",
                "h2o": "ADD H2O",
                "none": "SO FAR SO GOOD"
            }
        },
        "baloon": {
            "0": {
                "text": "Tutti sanno che una cosa è impossibile da realizzare, finché non arriva uno sprovveduto che non lo sa e la inventa.",
                "author": "Albert Einstein"
            },
            "1": {
                "text": "La creatività è contagiosa. Trasmettila.",
                "author": "Albert Einstein"
            },
            "2": {
                "text": "C’è una forza motrice più forte del vapore, dell’elettricità e dell’energia atomica: la volontà.",
                "author": "Albert Einstein"
            }
        },
        "role": {
            "dialog": {
                "no": "You cannot edit this value."
            }
        },
        "irrigation": {
            "local": {
                "2": "ON",
                "0": "OFF"
            }
        }
    },
    "text-err": {
        "required": "required field",
        "photo-nagative": "no negative number",
        "photo-ivalid": "Invalid values",
        "photo-zero": "The total must not be zero",
        "required-array": "insert at least one element",
        "same-passwords": "both passwords must be the same",
        "token-expired": "The session has expired. Please log in again",
        "illegal": "It cannot have this value"
    }
}